module.exports = __webpack_public_path__ + "static/media/logo-twitter.57d18e67.svg";